import React from 'react';
import { withTranslation } from 'react-i18next';
import withStyles from '@mui/styles/withStyles';
import Input from '../custom-comp/Input';

const styles = theme => ({
    mainDiv:{
        width:'70%',
        boxShadow: '0px 2px 4px -1px rgba(0,0,0,0.2)',
        borderRadius:'8px',
        display:'flex',
        flexDirection:'column',
        justifyContent:'space-around',
        padding: '10px 10px',
        margin:'10px 0px',
        alignSelf:'center',
        border:'1px solid #e4e8ed',
        [theme.breakpoints.between('xs','md')]: {
            width:'calc(100% - 20px)'
		}
    },

    input:{
        display: 'block',
        margin: '10px 0 20px 0',
        maxWidth: '40%',
        width: '40%',
        minWidth: '40%',
        padding: '10px 14px',
        fontFamily: 'inherit',
        fontSize: '1em',
        outline: 0,
        borderRadius: '4px',
        backgroundColor: '#F4F6F8',
        border:'1px solid #E5E5E5',
        [theme.breakpoints.between('xs','md')]: {
            fontSize:'0.8em'
		}
    },

    header:{
        fontFamily:"'Poppins', sans-serif",
        fontWeight:'bold',
    },

    inputDiv:{
        display:'flex',
        flexDirection:'row',
        alignItems:'center'
    },

    btn:{
        fontFamily:"'Poppins', sans-serif",
        color:'#0F467A',
        cursor:'pointer'
    },

    marLeft:{
        marginLeft:'10px',
    },

    marRight:{
        marginRight:'10px',
    }
})

class VoucherSection extends React.Component {
    render() {
        const { voucherMsg, voucherCode, checkVoucher, onChangeHandle, classes, i18n,t } = this.props;
        const isRTL = i18n.translator.language;
        const ar = "'Cairo', sans-serif";
        const en = "'Poppins', sans-serif";
        const fontFamily = isRTL === 'ar' ? ar : en;
        return(
            <div className={classes.mainDiv}>
                <span className={classes.header} style={{fontFamily:'inherit'}}>{t('booking.vo-title')}</span>
                <div className={classes.inputDiv}>
                    <Input {...{className:classes.input,type:'text',value:voucherCode,id:'voucherCode',onChange:onChangeHandle,placeholder:'Voucher Code'}}/>
                    <span className={`${classes.btn} ${isRTL === 'ar' ? classes.marRight : classes.marLeft}`} style={{fontFamily:'inherit'}} onClick={checkVoucher}>{t('booking.vo-btn')}</span>
                </div>
                {voucherMsg && <span style={{fontSize:'9px',color:voucherMsg === "Voucher code discount applied" ? 'green' : 'red',fontFamily:'inherit' }}>{voucherMsg === 'Voucher code discount applied' ? t('booking.voucherMsg.msg') : t('booking.voucherMsg.msg2')}</span>}
            </div>
        )}
}

export default withStyles(styles)(withTranslation('common')(VoucherSection));